import React from "react";
import GradientText from "../../../../components/GradientText";
import { getMessage } from "../../../../lib/translator";
import CartIcon from "./CartIcon";
import CustomersIcon from "./CustomersIcon";
import { Link } from "react-router-dom";
import { getTimeSince } from "./utils";
import { getPrintableTime } from "../../../../lib/datetime";

export default function NotificationsListUI({
  data = [],
  handleNotifyItemClick,
  read,
}) {
  return (
    <>
      {data.length > 0 ? (
        <>
          <GradientText
            text={
              read
                ? getMessage("previous.notifications.text")
                : getMessage("unread.notifications.text")
            }
            additionalclasses={`notify-section-heading ${read ? "read" : ""}`}
          />
          <div className="notify-list">
            {data.map((data) => {
              const { notification, id, createdAt, category } = data;
              const { aps, orderNumber, customerId } =
                notification.apns.payload;
              const { title, body } = aps.alert;
              return (
                <div
                  key={id}
                  className={`notify-item ${read ? "read" : ""}`}
                  onClick={(e) => !read && handleNotifyItemClick(e, id)}
                >
                  <div className="icon">
                    {category === "order" ? (
                      <CartIcon stroke={read ? "#787872" : ""} />
                    ) : (
                      <CustomersIcon stroke={read ? "#787872" : ""} />
                    )}
                  </div>
                  <div className="content">
                    <div className="notify-title">
                      <Link
                        className="notify-link"
                        to={
                          category === "order"
                            ? `/operations/orders/${orderNumber}`
                            : `/customer-support/customers/view/${customerId}`
                        }
                      >
                        {title}
                      </Link>
                    </div>
                    <div className={`notify-body ${read ? "read" : ""}`}>
                      {body}
                    </div>
                    <div className="meta-data">
                      <span>{getTimeSince(createdAt)}</span>
                      <div className="dot"></div>
                      <span>
                        {getPrintableTime(createdAt)
                          ?.split(" ")
                          ?.slice(0, 2)
                          ?.join(" ")}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : null}
    </>
  );
}
